import FadeInSection from '../../../components/feature/FadeInSection';

export default function GreetingHeroSection() {
  return (
    <section
      className="relative flex items-center justify-center"
      style={{ minHeight: '380px', paddingTop: '72px' }}
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/greetinghero.jpg"
          alt="和はは ご挨拶 - 代表からのメッセージ"
          className="w-full h-full object-cover object-top"
          loading="eager"
          width={1920}
          height={600}
        />
        <div
          className="absolute inset-0"
          style={{ background: 'rgba(74,55,40,0.52)' }}
        />
      </div>

      <div className="relative content-width text-center px-4 py-16">
        <FadeInSection>
          <p
            className="inline-block px-5 py-1.5 rounded-full text-sm font-bold mb-5"
            style={{
              background: 'rgba(255,255,255,0.2)',
              color: '#fff',
              border: '1px solid rgba(255,255,255,0.5)',
            }}
          >
            ご挨拶
          </p>
          <h1
            className="text-white mb-5"
            style={{
              fontSize: 'clamp(28px, 4vw, 40px)',
              fontWeight: '700',
              lineHeight: '1.5',
              textShadow: '0 2px 8px rgba(0,0,0,0.3)',
            }}
          >
            MESSAGE
          </h1>
        </FadeInSection>
      </div>
    </section>
  );
}
